import {
  MUTATION_CATALOG_ITEM_SET_QNT,
  MUTATION_CATALOG_ITEM_SET_PRICE,
  MUTATION_CATALOG_SET,
  MUTATION_SET_COMPAT_FILTER,
  MUTATION_CONFIGURATION_SET,
  MUTATION_EMAIL_SET,
  MUTATION_ORDER_SET,
  MUTATION_PHONE_SET,
  MUTATION_SHOPPING_CART_CLEAR,
  MUTATION_SHOPPING_CART_INIT,
  MUTATION_SHOPPING_CART_ITEM_SET_QNT,
  MUTATION_SHOPPING_CART_ITEM_SET_PRICE,
  MUTATION_VISIT_DATE_SET,
  MUTATION_CONFIG_STATIC_IMAGES,
  MUTATION_IMAGES_SET,
  MUTATION_SET_IMAGES_VERSION
} from '@/store/const-mutations';

export const mutations = {
  [MUTATION_CONFIGURATION_SET] (state, payload) {
    state.configuration = Object.assign({}, state.configuration, payload);
  },

  [MUTATION_PHONE_SET] (state, payload) {
    state.phone = payload.phone;
  },

  [MUTATION_EMAIL_SET] (state, payload) {
    state.email = payload.email;
  },

  [MUTATION_ORDER_SET] (state, payload) {
    state.order = Object.assign({}, state.order, payload);
  },

  [MUTATION_CATALOG_SET] (state, payload) {
    state.catalog = payload;
  },

  [MUTATION_SET_COMPAT_FILTER] (state, payload) {
    state.compatFilter = payload;
  },

  [MUTATION_CATALOG_ITEM_SET_QNT] (state, payload) {
    state.catalog[payload.index].qnt = payload.qnt;
  },

  [MUTATION_CATALOG_ITEM_SET_PRICE] (state, payload) {
    state.catalog[payload.index].price = payload.price;
  },

  [MUTATION_SHOPPING_CART_INIT] (state, payload) {
    if (!state.catalog) {
      state.shoppingCart = [];    
    }
    state.shoppingCart = state.catalog.filter(item => item.qnt !== 0).sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
  },

  [MUTATION_SHOPPING_CART_CLEAR] (state, payload) {
    state.shoppingCart = [];    
  },

  [MUTATION_SHOPPING_CART_ITEM_SET_QNT] (state, payload) {
    const item = state.shoppingCart[payload.index];
    const catalogItem = state.catalog.find(i => i.productId === item.productId);

    if (payload.qnt === 0) {
      state.shoppingCart.splice(payload.index, 1);
      if (catalogItem) {
        catalogItem.qnt = 0; 
      }
      return;
    }

    state.shoppingCart[payload.index].qnt = payload.qnt;
    if (catalogItem) {
      catalogItem.qnt = payload.qnt; 
    }
  },

  [MUTATION_SHOPPING_CART_ITEM_SET_PRICE] (state, payload) {
    if (payload.price === 0) { 
      state.shoppingCart.splice(payload.index, 1);
      return;
    }
    state.shoppingCart[payload.index].price = payload.price;
  },

  [MUTATION_VISIT_DATE_SET] (state, payload) {
    state.visitDate = payload.visitDate;
  },

  [MUTATION_CONFIG_STATIC_IMAGES] (state, payload) {
    state.configuration.logo = payload.logo || null;
    state.configuration.logo2 = payload.logo2 || null;
    state.configuration.paymentGateway = payload.paymentGateway || null;
  },

  [MUTATION_IMAGES_SET] (state, images) {
    state.configuration.images = images || {};
  },

  [MUTATION_SET_IMAGES_VERSION] (state, version) {
    state.configuration.imagesVersion = version;
  }
};
